/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCatalog200ResponseCategoriesInnerProductsInnerType
 */
export interface GetCatalog200ResponseCategoriesInnerProductsInnerType {
}

/**
 * Check if a given object implements the GetCatalog200ResponseCategoriesInnerProductsInnerType interface.
 */
export function instanceOfGetCatalog200ResponseCategoriesInnerProductsInnerType(value: object): value is GetCatalog200ResponseCategoriesInnerProductsInnerType {
    return true;
}

export function GetCatalog200ResponseCategoriesInnerProductsInnerTypeFromJSON(json: any): GetCatalog200ResponseCategoriesInnerProductsInnerType {
    return GetCatalog200ResponseCategoriesInnerProductsInnerTypeFromJSONTyped(json, false);
}

export function GetCatalog200ResponseCategoriesInnerProductsInnerTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCatalog200ResponseCategoriesInnerProductsInnerType {
    return json;
}

export function GetCatalog200ResponseCategoriesInnerProductsInnerTypeToJSON(json: any): GetCatalog200ResponseCategoriesInnerProductsInnerType {
    return GetCatalog200ResponseCategoriesInnerProductsInnerTypeToJSONTyped(json, false);
}

export function GetCatalog200ResponseCategoriesInnerProductsInnerTypeToJSONTyped(value?: GetCatalog200ResponseCategoriesInnerProductsInnerType | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

